const GA_NOT_CONNECTED = "activation.home.ga.not.connected.text";

export const ACTIVATION_SETTINGS_TOOLTIP = "activation.common.settings.tooltip";
export const ACTIVATION_SHARED_TOOLTIP = "activation.shared.tooltip";
